import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {FrapperService} from "./frapper.service";
import {AssignedService} from "./assigned.service";
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {

  Doctype_tribunal ='Tribunal'
  Doctype_unite_organisationnel ='Unite_Organisationnelle'
  Doctype_fonctions ='Fonction'

  Doctype_system_role ='Rôle'

  constructor(private http: HttpClient, private frapper: FrapperService, private assigneService:AssignedService,private authservice: AuthService) {}

 //Tribunal
  // Creation des tribunaux ; a la creation d'un tribunal il va creer par defaut 1 referentiel organisationnel puis 3 unite organisationel de type Service
  // et dont est_sous_unite = 0
  async getAllMyTribunal(filter=null) {
    try {
      let my_tribunals = await this.frapper.GetDoctypes(this.Doctype_tribunal,'["*"]',filter).toPromise()
      //console.log('My Courriers Principale ===> ', my_courriers)
      return my_tribunals
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async nouveauTribunal(body) {
    try {
      let new_tribunal = await this.frapper.CreateDoctype(this.Doctype_tribunal,body).toPromise()
      return new_tribunal
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async getOneTribunal(tribunalName) {
    try {
      let my_tribunal = await this.frapper.GetDoctype(this.Doctype_tribunal,tribunalName,'["*"]',null).toPromise()
      //console.log('Information Of The Courriers ===> ', my_courrier)
      return my_tribunal
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateTribunal(docname,body){
    try {
      let result = this.frapper.UpdateDoctype(this.Doctype_tribunal,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

 // * Tribunal

  async getAllSystemRole(filter=null) {
    try {
      let sys_role = await this.frapper.GetDoctypes(this.Doctype_system_role,'["*"]',filter).toPromise()
      //console.log('My Courriers Principale ===> ', my_courriers)
      return sys_role
    } catch (error) {
      this.authservice.handleError(error)
    }

  }
  //Unite Organisationnel

  /* N1 = Services (Service)
  *  N2 = Bureau (Bureau)
  *  N3 = Poste (Poste) ou chanbre cabinet (ChambreCabinet)
  * */

  async getAllUniteOrganisationnelle(filter=null) {
    try {
      let my_unites = await this.frapper.GetDoctypes(this.Doctype_unite_organisationnel,'["*"]',filter).toPromise()
      //console.log('My Courriers Principale ===> ', my_courriers)
      return my_unites
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async nouvelleUniteOrganisationnelle(body) {
    try {
      let new_UO = await this.frapper.CreateDoctype(this.Doctype_unite_organisationnel,body).toPromise()
      return new_UO
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async getOneUniteOrganisationnelle(UOName) {
    try {
      let my_UO = await this.frapper.GetDoctype(this.Doctype_unite_organisationnel,UOName,'["*"]',null).toPromise()
      //console.log('Information Of The Courriers ===> ', my_courrier)
      return my_UO
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateUniteOrganisationnelle(docname,body){
    try {
      let result = this.frapper.UpdateDoctype(this.Doctype_unite_organisationnel,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  // *Unite Organisationnel


//Functions


  async getAllFunctions(filter=null) {
    try {
      let my_result = await this.frapper.GetDoctypes(this.Doctype_fonctions,'["*"]',filter).toPromise()
      //console.log('My Courriers Principale ===> ', my_courriers)
      return my_result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async nouvelleFunction(body) {
    try {
      let my_result = await this.frapper.CreateDoctype(this.Doctype_fonctions,body).toPromise()
      return my_result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async getOneFunction(UOName) {
    try {
      let my_result = await this.frapper.GetDoctype(this.Doctype_fonctions,UOName,'["*"]',null).toPromise()
      //console.log('Information Of The Courriers ===> ', my_courrier)
      return my_result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateFunction(docname,body){
    try {
      let result = this.frapper.UpdateDoctype(this.Doctype_fonctions,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  // *Functions
}
